// removed by extract-text-webpack-plugin
module.exports = {"defaultInput":"_2TiQHvQz","content":"_11gggB4f","title":"_3ywpocAr"};


//////////////////
// WEBPACK FOOTER
// ./src/client/webapp/pages/UserPaymentsPage/UserPaymentsPage.styl
// module id = 550
// module chunks = 0